import { useNavigate } from "@tanstack/react-router";

export const useNavigateChart = () => {
  const navigate = useNavigate();

  return ({
    patientId,
    encounterId,
  }: { patientId: string; encounterId?: string }) => {
    const search = {} as Record<string, string>;

    if (encounterId) {
      search.encounterId = encounterId;
    }

    navigate({
      to: "/patient/$patientId",
      params: {
        patientId,
      },
      replace: true,
      search,
    });
  };
};
